import { config } from './config';
import { httpUtil } from './httpUtil';
import { contacts } from './contacts';
import { lab4services } from './lab4services';
import { paymentgateway } from './paymentgateway';
import { paygateservices } from './paygateservices';
import { account } from './account';
import { subscriptions } from './subscriptions';
export default {
  setupChannel: httpUtil.setupChannel,
  getSession : httpUtil.getSession,
  startSession: httpUtil.startSession,
  cleanSession: httpUtil.startSession,
  config: config,
  contacts: contacts,
  lab4services: lab4services,
  paymentgateway:paymentgateway,
  paygateservices: paygateservices,
  paymentgateway: paymentgateway,
  account: account,
  subscriptions: subscriptions,
}